import AppDropdownMenu from '@/components/DropdownMenu/DropdownMenuV2.vue';

export default {
    AppDropdownMenu,
};
